import React from 'react';
import { useInView } from '../hooks/useInView';
import { useLanguage } from '../context/LanguageContext';
import { teamMembers } from '../data/mock';

// Tačan redosled slika prema tvojim fajlovima u public folderu:
// 1. Ana (ana.jpg)
// 2. Bilja (bilja.jpg)
// 3. Đurđa (djurdja.jpg)
// 4. Hana (hana.jpg)
const teamImages = [
  '/ana.jpg',
  '/bilja.jpg',
  '/djurdja.jpg',
  '/hana.jpg'
];

const TeamCard = ({ member, index, isInView, image }) => {
  return (
    <div
      className="group relative"
      style={{
        opacity: isInView ? 1 : 0,
        transform: isInView ? 'translateY(0) rotateX(0deg)' : 'translateY(80px) rotateX(20deg)',
        transition: `all 1.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) ${0.4 + index * 0.2}s`
      }}
    >
      <div className="relative overflow-hidden bg-gray-800 aspect-[3/4]">
        <img
          src={image}
          alt={member.name}
          className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105"
        />
        
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-80" />
        
        <div className="absolute top-0 right-0 w-16 h-16">
          <div className="absolute top-0 right-0 w-0 h-0 border-t-[60px] border-t-[#0067ff] border-l-[60px] border-l-transparent transition-all duration-300 group-hover:border-t-[80px] group-hover:border-l-[80px]" />
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-6">
          <h3 className="text-white text-xl font-serif font-bold mb-1">
            {member.name}
          </h3>
          <p 
            className="text-[#0067ff] text-sm uppercase tracking-widest"
            style={{ textShadow: '1px 1px 3px rgba(0, 0, 0, 0.8), 2px 2px 4px rgba(0, 0, 0, 0.5)' }}
          >
            {member.position}
          </p>
        </div>
      </div>
    </div>
  );
};

const TeamSection = () => {
  const { t } = useLanguage();
  const [ref, isInView] = useInView({ threshold: 0.1 });

  return (
    <section
      id="tim"
      ref={ref}
      className="py-24 lg:py-32 bg-[#545857]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span 
            className="text-[#0067ff] text-base md:text-lg uppercase tracking-widest font-medium mb-4 block"
            style={{
              opacity: isInView ? 1 : 0,
              transform: isInView ? 'perspective(400px) rotateY(0deg)' : 'perspective(400px) rotateY(-120deg)',
              transformOrigin: 'left center',
              transition: 'all 1.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
              textShadow: '1px 1px 3px rgba(0, 0, 0, 0.8), 2px 2px 4px rgba(0, 0, 0, 0.5)'
            }}
          >
            {t.team.label}
          </span>
          <h2 
            className="text-4xl md:text-5xl font-serif font-bold text-white mb-6"
            style={{
              opacity: isInView ? 1 : 0,
              filter: isInView ? 'blur(0px)' : 'blur(25px)',
              transform: isInView ? 'scale(1)' : 'scale(1.3)',
              transition: 'all 1.4s ease-out 0.3s'
            }}
          >
            {t.team.title}
          </h2>
          <h3 
            className="text-gray-300 text-lg font-light mb-6 max-w-2xl mx-auto"
            style={{
              opacity: isInView ? 1 : 0,
              transition: 'all 1s ease-out 0.5s'
            }}
          >
            {t.team.subtitle}
          </h3>
          <div 
            className="h-1 bg-[#0067ff] mx-auto"
            style={{
              width: isInView ? '5rem' : '0',
              opacity: isInView ? 1 : 0,
              transition: 'all 1.2s ease-out 0.6s'
            }}
          />
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {teamMembers.map((member, index) => (
            <TeamCard
              key={member.id}
              member={member}
              index={index}
              isInView={isInView}
              image={teamImages[index]}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;